const strings = {
  START_TIME: 'Starttid',
  END_TIME: 'Sluttid',
  NEW_LAUNDRY_TIME: 'Ny tvättid',
  CANCEL: 'Avbryt',
  DELETE_LAUNDRY_TIME: 'Ta bort tvättid',
  DELETE_LAUNDRY_TIME_INFO:
    'Är du säker på att du vill ta bort tvättiden? Detta kan inte göras ogjort.',
  YES: 'Ja',
  NO: 'Nej',
  MANAGE_LAUNDRY_TIMES: 'Hantera tvättider',
  AVAILABILITY: 'Tillgänglighet'
}

export default strings



// WEBPACK FOOTER //
// ./src/components/containers/LaundryTimesTable/strings.js